export {
  Structure,
  SharedPlaceMessage,
  DuplexStructureMessage,
  type StructureProps,
  type DuplexStructureMessageProps,
} from './index.pc'
export {
  MobileStructure,
  MobileSharedPlaceMessage,
  MobileDuplexStructureMessage,
} from './index.mobile'
